import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("hesttya_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("hesttya_token");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const fetchDashboard = (snapshotId) =>
  api.get("/dashboard", { params: snapshotId ? { snapshot_id: snapshotId } : {} }).then((r) => r.data);

export const fetchSnapshots = (params = {}) => api.get("/snapshots", { params }).then((r) => r.data);

export const deleteSnapshot = (id) => api.delete(`/snapshots/${id}`).then((r) => r.data);

export const fetchConsultores = (params = {}) =>
  api.get("/consultores", { params }).then((r) => r.data);

export const fetchConsultor = (cid, snapshotId) =>
  api.get(`/consultores/${cid}`, { params: snapshotId ? { snapshot_id: snapshotId } : {} }).then((r) => r.data);

export const updateConsultor = (cid, data, snapshotId) =>
  api
    .put(`/consultores/${cid}`, data, { params: snapshotId ? { snapshot_id: snapshotId } : {} })
    .then((r) => r.data);

export const fetchJerarquia = (snapshotId) =>
  api.get("/jerarquia", { params: snapshotId ? { snapshot_id: snapshotId } : {} }).then((r) => r.data);

export const fetchAlertas = (snapshotId) =>
  api.get("/alertas", { params: snapshotId ? { snapshot_id: snapshotId } : {} }).then((r) => r.data);

export const fetchHistorico = (params = {}) => api.get("/historico", { params }).then((r) => r.data);
export const fetchHistoricoConsultoras = (params = {}) => api.get("/historico/consultoras", { params }).then((r) => r.data);

export const fetchCierreMes = (snapshotId) =>
  api.get("/cierre-mes", { params: snapshotId ? { snapshot_id: snapshotId } : {} }).then((r) => r.data);

// Objetivos
export const listObjetivos = (params = {}) => api.get("/objetivos", { params }).then((r) => r.data);
export const createObjetivo = (data) => api.post("/objetivos", data).then((r) => r.data);
export const updateObjetivo = (id, data) => api.put(`/objetivos/${id}`, data).then((r) => r.data);
export const deleteObjetivo = (id) => api.delete(`/objetivos/${id}`).then((r) => r.data);

// Ventajas
export const listVentajas = (params = {}) => api.get("/ventajas", { params }).then((r) => r.data);
export const createVentaja = (data) => api.post("/ventajas", data).then((r) => r.data);
export const getVentaja = (id) => api.get(`/ventajas/${id}`).then((r) => r.data);
export const updateVentaja = (id, data) => api.put(`/ventajas/${id}`, data).then((r) => r.data);
export const deleteVentaja = (id) => api.delete(`/ventajas/${id}`).then((r) => r.data);
export const ventajaProgreso = (id, snapshotId) =>
  api.get(`/ventajas/${id}/progreso`, { params: snapshotId ? { snapshot_id: snapshotId } : {} }).then((r) => r.data);

export const updateCoordenadorSales = (snapshotId, data) =>
  api.put(`/snapshots/${snapshotId}/coordenador`, data).then((r) => r.data);

export const syncFromHesttya = (year, month, startDate, endDate) =>
  api.post("/sync", null, { params: { year, month, start_date: startDate, end_date: endDate } }).then((r) => r.data);

export const syncCoordinador = (userId, year, month) =>
  api.post(`/sync/coordinador/${userId}`, null, { params: { year, month } }).then((r) => r.data);

export const getSyncStatus = () => api.get("/sync/status").then((r) => r.data);
export const updateSyncConfig = (data) => api.put("/sync/config", data).then((r) => r.data);

export const uploadCsv = async (file, period, label, snapshotDate, replaceExisting) => {
  const fd = new FormData();
  fd.append("file", file);
  if (period) fd.append("period", period);
  if (label) fd.append("label", label);
  if (snapshotDate) fd.append("snapshot_date", snapshotDate);
  if (replaceExisting) fd.append("replace_existing", "true");
  const res = await api.post("/upload-csv", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

// Auth
export const loginUser = (email, password) =>
  api.post("/auth/login", { email, password }).then((r) => r.data);

export const registerUser = (nombre, email, password, id_consultor = null) =>
  api.post("/auth/register", { nombre, email, password, id_consultor }).then((r) => r.data);

export const fetchProfile = () => api.get("/auth/profile").then((r) => r.data);
export const updateProfile = (data) => api.put("/auth/profile", data).then((r) => r.data);

// Global (superadmin/admin — all coordinators aggregated, optionally filtered by pais)
export const fetchGlobalDashboard = (pais) =>
  api.get("/global/dashboard", { params: pais ? { pais } : {} }).then((r) => r.data);
export const fetchGlobalConsultores = (params = {}) =>
  api.get("/global/consultores", { params }).then((r) => r.data);
export const fetchGlobalAlertas = (pais) =>
  api.get("/global/alertas", { params: pais ? { pais } : {} }).then((r) => r.data);
export const fetchGlobalCierreMes = (pais) =>
  api.get("/global/cierre-mes", { params: pais ? { pais } : {} }).then((r) => r.data);
export const fetchGlobalJerarquia = (pais) =>
  api.get("/global/jerarquia", { params: pais ? { pais } : {} }).then((r) => r.data);

// Users (superadmin only)
export const fetchUsers = () => api.get("/users").then((r) => r.data);
export const createUser = (data) => api.post("/users", data).then((r) => r.data);
export const updateUser = (id, data) => api.put(`/users/${id}`, data).then((r) => r.data);
export const deleteUser = (id) => api.delete(`/users/${id}`).then((r) => r.data);